class ModelAdapter {

  constructor () {
    this.field2ControlType = this.field2ControlType.bind(this)
    this.fieldOptionName = this.fieldOptionName.bind(this)
    this.fieldTextDisplay = this.fieldTextDisplay.bind(this)
  }

  field2ControlType (fieldMeta) {
    var field2ControlMap = new Map()
    field2ControlMap.set('TextField', 'multiLineText')
    field2ControlMap.set('HTMLField', 'richText')
    field2ControlMap.set('FloatField', 'number')
    field2ControlMap.set('ForeignKey', 'select')
    field2ControlMap.set('DateField', 'date')
    field2ControlMap.set('DateTimeField', 'datetime')
    field2ControlMap.set('AlbumField', 'multiImage')
    field2ControlMap.set('ImageField', 'image')
    field2ControlMap.set('BooleanField', 'checkbox')
    field2ControlMap.set('SlidesField', 'multiSlide')
    field2ControlMap.set('YuanField', 'yuan')
    field2ControlMap.set('OrderDetailField', 'orderDetail')

    let fieldType = fieldMeta['field_type']

    if (field2ControlMap.has(fieldType)) {
      return field2ControlMap.get(fieldType)
    } else {
      if (fieldType === 'CharField') {
        if (fieldMeta['max_length'] < 500) {
          return 'lineText'
        } else {
          return 'multiLineText'
        }
      } else if (fieldType === 'IntegerField') {
        if (fieldMeta['choices'].length > 0) {
          return 'select'
        } else {
          return 'number'
        }
      }
    }
  }

  fieldOptionName (fieldMeta) {
    let baseFieldName = ''
    if (fieldMeta['field_type'] === 'ForeignKey') {
      baseFieldName = fieldMeta['field_name'].slice(0, -3)
    } else {
      baseFieldName = fieldMeta['field_name']
    }
    return baseFieldName + '_options'
  }

  fieldTextDisplay(obj, fieldName, fieldSpec) {
    let text = '' + obj[fieldName]
    fieldSpec.forEach(function (fieldMeta) {
      if (fieldMeta['field_name'] === fieldName) {
        if (fieldMeta['choices'].length > 0) {
          text = obj[fieldName + '_label']
        } else if (fieldMeta['field_type'] === 'BooleanField') {
          text = obj[fieldName] ? '是' : '否'
        } else if (fieldMeta['field_type'] === 'YuanField') {
          text = obj[fieldName] / 100 + ''
        }
      }
    })
    return text
  }
}

export default {
  ModelAdapter: ModelAdapter
}



// WEBPACK FOOTER //
// ./src/service/modeladapter.js